import { render } from "./CartShipping.vue?vue&type=template&id=558ae96c"
import script from "./CartShipping.vue?vue&type=script&lang=js"
export * from "./CartShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__